export const ACCRUED_INTEREST = [
  { id: 'INCLUDE_ACCRUED_INTEREST', displayValue: 'Include Accrued Interest' },
  { id: 'EXCLUDE_ACCRUED_INTEREST', displayValue: 'Exclude Accrued Interest' },
  { id: 'NOT_APPLICABLE', displayValue: 'Not Applicable' },
];
